/**
 * Warstwa API modułu: fundament — pozycje procesu HR (checklista onboardingu/offboardingu).
 * Właściciel: FALA 0b, agent C (docs/PROJEKT-00-FUNDAMENT-2026-09-02.md §5, §6).
 * Trasy backendu: api/hr-process, api/tickets/{id}/process-tasks.
 *
 * Kontrakt: `attach(api)` dostaje instancję axios z apiService.js (interceptory JWT, cache GET, obsługa 401)
 * i zwraca OBIEKT nazwanych metod, które apiService.js doczepia do wspólnego `apiService` (jedno miejsce,
 * src/api/modules/index.js). Nazwy metod muszą być unikalne w całej aplikacji — kolizja zatrzymuje start
 * (patrz attachApiModules). Tego pliku nie dotyka nikt poza właścicielem modułu.
 *
 * UWAGA: „rozliczone / nie dotyczy / otwórz ponownie" ma DWA wejścia — kartę zgłoszenia (agent IT)
 * i okno sprawy (kadry, przełożony). Obydwa trafiają w tę samą bramkę po stronie serwera
 * (IHrProcessTaskService.CanCompleteAsync), więc front nie decyduje o niczym — jedynie chowa przyciski,
 * których i tak nie wolno kliknąć (pole `canComplete` w odpowiedzi).
 */
export function attach(api) {
    return {
        // ── Karta zgłoszenia (agent desku) ──────────────────────────────
        getTicketProcessTasks: (ticketId) => api.get(`/tickets/${ticketId}/process-tasks`),

        /**
         * @param {string} decision "done" | "not-applicable" | "reopen"
         */
        setTicketProcessTaskState: (ticketId, taskId, decision, data = {}) =>
            api.post(`/tickets/${ticketId}/process-tasks/${taskId}/${decision}`, data),

        // ── Okno sprawy (kadry, przełożony) ─────────────────────────────
        /**
         * @param {string} kind "onboarding" | "offboarding"
         */
        getHrProcessCaseTasks: (kind, caseId) => api.get(`/hr-process/cases/${kind}/${caseId}/tasks`),

        setHrProcessTaskDone: (taskId, data = {}) => api.post(`/hr-process/tasks/${taskId}/done`, data),

        setHrProcessTaskNotApplicable: (taskId, data = {}) =>
            api.post(`/hr-process/tasks/${taskId}/not-applicable`, data),

        reopenHrProcessTask: (taskId, data = {}) => api.post(`/hr-process/tasks/${taskId}/reopen`, data),

        addHrProcessManualTask: (data) => api.post("/hr-process/tasks/manual", data),

        // ── [BA-10 2026-09-18] Dowód rozliczenia ────────────────────────
        /** Plik (zrzut ekranu / PDF) wgrywany PRZED decyzją „done” — odpowiedź niesie świeże `updatedAt` pozycji. */
        uploadHrProcessTaskEvidence: (taskId, plik) => {
            const fd = new FormData();
            fd.append("plik", plik);
            return api.post(`/hr-process/tasks/${taskId}/dowod`, fd, { headers: { "Content-Type": "multipart/form-data" } });
        },
        /** Pobranie dowodu jako blob (końcówka wymaga nagłówka JWT, więc nie zwykły odnośnik). */
        pobierzDowodHrProcessTask: (taskId) => api.get(`/hr-process/tasks/${taskId}/dowod`, { responseType: "blob" }),
    };
}
